import React, { memo } from 'react';
import './StatusBadge.css';

const StatusBadge = memo(({ 
  status, 
  color, 
  children, 
  className = '' 
}) => {
  const badgeStyle = color ? { backgroundColor: color } : {};
  
  return (
    <span 
      className={`status-badge ${className}`}
      style={badgeStyle}
    >
      {children || status}
    </span>
  );
});

StatusBadge.displayName = 'StatusBadge';

export default StatusBadge;
